var map = {
	"./cat": 6199,
	"./cat.js": 6199,
	"./cd": 44960,
	"./cd.js": 44960,
	"./chmod": 54038,
	"./chmod.js": 54038,
	"./common": 24014,
	"./common.js": 24014,
	"./cp": 11516,
	"./cp.js": 11516,
	"./dirs": 879,
	"./dirs.js": 879,
	"./echo": 9782,
	"./echo.js": 9782,
	"./error": 44589,
	"./error.js": 44589,
	"./exec": 54606,
	"./exec-child": 99497,
	"./exec-child.js": 99497,
	"./exec.js": 54606,
	"./find": 54540,
	"./find.js": 54540,
	"./grep": 39531,
	"./grep.js": 39531,
	"./head": 70881,
	"./head.js": 70881,
	"./ln": 23333,
	"./ln.js": 23333,
	"./ls": 93074,
	"./ls.js": 93074,
	"./mkdir": 97052,
	"./mkdir.js": 97052,
	"./mv": 92119,
	"./mv.js": 92119,
	"./popd": 56046,
	"./popd.js": 56046,
	"./pushd": 53707,
	"./pushd.js": 53707,
	"./pwd": 21252,
	"./pwd.js": 21252,
	"./rm": 67862,
	"./rm.js": 67862,
	"./sed": 50027,
	"./sed.js": 50027,
	"./set": 21819,
	"./set.js": 21819,
	"./sort": 90271,
	"./sort.js": 90271,
	"./tail": 35633,
	"./tail.js": 35633,
	"./tempdir": 13482,
	"./tempdir.js": 13482,
	"./test": 23655,
	"./test.js": 23655,
	"./to": 32990,
	"./to.js": 32990,
	"./toEnd": 79253,
	"./toEnd.js": 79253,
	"./touch": 75584,
	"./touch.js": 75584,
	"./uniq": 19850,
	"./uniq.js": 19850,
	"./which": 80366,
	"./which.js": 80366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20032;